/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    Label,
    FormGroup,
    Row,
    // Label,
    Input,
    Button,
    // Table,
    // Form,
    // Badge,
    // Input,
    CardHeader,
    CardFooter,
    Col,
    Container,
} from "reactstrap";
import axios from "axios";
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile";
import { Link, useHistory } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import ItemGambar1 from "components/SelectedFile/ItemGambar1";
import ItemGambar2 from "components/SelectedFile/ItemGambar2";
import ItemGambar3 from "components/SelectedFile/ItemGambar3";
import ItemGambar4 from "components/SelectedFile/ItemGambar4";
import ItemGambar5 from "components/SelectedFile/ItemGambar5";

export default function CreateDokumentCanvasingByParent(props) {
    const warehouse = localStorage.warehouse;
    const token = localStorage.token;
    const username = localStorage.username;
    const trackingcode = localStorage.tc;
    const [description, setDescription] = useState("");
    const [long, setLong] = useState(0);
    const [lat, setLat] = useState(0);
    const [alamat, setAlamat] = useState("");
    const [whatsapp, setWhatsapp] = useState("");
    const [namaproyek, setNamaProyek] = useState("");
    const [namacustomer, setNamaCustomer] = useState("");
    const [customer, setCustomer] = useState("");
    let history = useHistory();

    const [alert, setAlert] = React.useState(null);

    const [kodeparent, setKodeParent] = useState("");
    const [loading, setLoading] = useState(false)
    const [isSpinner, setIsSpinner] = useState(false);

    const [image1, setImage1] = useState("");
    const [image2, setImage2] = useState("");
    const [image3, setImage3] = useState("");
    const [image4, setImage4] = useState("");
    const [image5, setImage5] = useState("");


    useEffect(() => {
        getById();
    }, []);

    const getById = () => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/canvasing-parent/get?code=${props.match.params.code}`, { headers })
            .then((data) => {
                const res = data.data.response;
                const lat = parseFloat(res.latitude_proyek);
                const lng = parseFloat(res.longitude_proyek);
                // setDescription(res.keterangan_canvasing);
                setAlamat(res.manual_alamat_proyek);
                setCustomer(res.customer_id);
                setKodeParent(res.canvasing_parent_code);
                setNamaCustomer(res.customer_name);
                setNamaProyek(res.nama_proyek);
                setWhatsapp(res.customer_phone);
                setLat(lat);
                setLong(lng);
            })
            .catch((error) => {
                console.log(error);
            });
    };


    const handleSubmit1 = () => {
        hideAlert();
        setTimeout(() => { CreateData() }, 1000);
    };

    const CreateData = () => {
        setIsSpinner(true);
        setLoading(true)
        hideAlert();

        const headers = {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
        };

        const myjson = JSON.stringify({
            warehouse_id: warehouse,
            username_sc: username,
            canvasing_parent_code: kodeparent,
            tracking_code: trackingcode,
            keterangan_canvasing: description,
            pic: "",
            pic_phone: "",
            customer_id: customer,
        });

        let data = new FormData();
        data.append("body", myjson)
        data.append("foto1", image1)
        data.append("foto2", image2)
        data.append("foto3", image3)
        data.append("foto4", image4)
        data.append("foto5", image5)
        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/canvasing/save`, data, { headers })
            .then(function (response) {
                setIsSpinner(false);
                setSuccessAlert(response.data.message);
                setLoading(false)
                setTimeout(() => (history.push("/mobile/sales/page")), 1000);
            })
            .catch(function (error) {
                setIsSpinner(false);
                setGagalAlert(error.response.data.message);
                setLoading(false)
            });
    }

    const setSuccessAlert = (id) => {
        setAlert(
            <SweetAlert
                success
                showConfirm
                confirmBtnText="Ok"
                title={id}
                timeout={1000}
                onCancel={hideAlert}
                onConfirm={hideAlert}
            />
        )
    }

    const setGagalAlert = (id) => {
        setAlert(
            <SweetAlert
                danger
                showConfirm
                confirmBtnText="Ok"
                title={id}
                onCancel={hideAlert}
                onConfirm={hideAlert}
            />
        );
    };

    const setQuestionAlert = () => {
        setAlert(
            <SweetAlert
                warning
                showCancel
                confirmBtnText="Lanjutkan"
                confirmBtnBsStyle="danger"
                title="Apakah Kamu Yakin?"
                onConfirm={handleSubmit1}
                onCancel={hideAlert}
                focusCancelBtn
            />
        );
    };

    const hideAlert = () => {
        setAlert(null);
    };

    return (
        <>
            {alert}
            <div>
                {isSpinner ? (
                    <Container className="mt--10 pb-10 login-container">
                        <Row className="justify-content-center">
                            <Col lg="5" md="7">
                                <div className="d-flex flex-column align-items-center d-lg-none d-xl-none">
                                    <img
                                        src={require("assets/img/theme/loadingmobile1.gif").default}
                                        style={{
                                            textAlign: "center",
                                            height: "12rem",
                                            width: "12rem",
                                            paddingTop: "1rem",
                                        }}
                                        alt="loading"
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Container>
                ) : (<>
                    <SimpleHeaderMobile to="/mobile/sales/page" />
                    <Container className="mt--6" fluid>
                        {lat && long ? (
                            <>
                                {/* <Card className="shadow mb-4">
                                <CardHeader>
                                    <h5 className="mb-0">Lokasi Proyek</h5>
                                </CardHeader>
                                <CardBody>
                                    <div style={{ height: "300px", width: "100%" }}>


                                        <p className="text-center">Loading lokasi proyek...</p>
                                    </div>
                                </CardBody>
                            </Card> */}

                                <Card className="shadow mb-4">
                                    <CardHeader className="bg-primary text-white">
                                        <h5 className="mb-0 text-white">📄 Detail Proyeks</h5>
                                    </CardHeader>
                                    <CardBody>
                                        {[
                                            { label: "Proyek", value: namaproyek },
                                            { label: "Customer", value: namacustomer },
                                            { label: "Alamat", value: alamat },
                                            {
                                                label: "WhatsApp", value: whatsapp ? (
                                                    <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer">{whatsapp}</a>
                                                ) : "-"
                                            }
                                        ].map((item, idx) => (
                                            <Row key={idx} className="mb-2">
                                                <Col xs="4" className="font-weight-bold text-sm">{item.label}</Col>
                                                <Col xs="8" className="text-sm">{item.value || "-"}</Col>
                                            </Row>
                                        ))}
                                    </CardBody>
                                </Card>

                                <Card className="shadow mb-4">
                                    <CardHeader className="bg-info text-white">
                                        <h5 className="mb-0 text-white">🛒 Deskripsi</h5>
                                    </CardHeader>

                                    <CardBody>
                                        <Row md="12">
                                            <Col md="6">
                                                <FormGroup row>
                                                    <Label
                                                        className="form-control-label"
                                                        for="exampleEmail"
                                                        sm={4}
                                                    >
                                                        Keterangan
                                                        <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col sm={7}>
                                                        <Input
                                                            autoComplete="off"
                                                            className="form-control-alternative"
                                                            type="textarea"
                                                            name="descripsi"
                                                            rows="8"
                                                            placeholder="Masukan Keterangan"
                                                            value={description}
                                                            onChange={(e) => {
                                                                setDescription(e.target.value);
                                                            }}
                                                        />
                                                    </Col>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Card className="bg-secondary shadow">
                                    <CardHeader>
                                        <h3>Upload Gambar</h3>
                                    </CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col md="12">
                                                <FormGroup>
                                                    {/* <Label className="form-control-label" for="exampleEmail">
                                                                                    <b>Foto Produk</b><br />
                                                                                    Format gambar .jpg .jpeg .png dan ukuran minimum <b>300px X 300px</b>.
                                                                                </Label> */}

                                                    <Row className="mt-3">
                                                        {[1, 2, 3, 4, 5].map((num, index) => (
                                                            <Col key={index} xs="6" sm="4" md="2" className="mb-3 text-center">
                                                                <label htmlFor={`formId${num}`} style={{ cursor: 'pointer' }}>
                                                                    <input
                                                                        hidden
                                                                        id={`formId${num}`}
                                                                        name="file"
                                                                        type="file"
                                                                        accept="image/*"
                                                                        onChange={(event) => {
                                                                            const file = event.target.files[0];
                                                                            if (file) {
                                                                                switch (num) {
                                                                                    case 1: setImage1(file); break;
                                                                                    case 2: setImage2(file); break;
                                                                                    case 3: setImage3(file); break;
                                                                                    case 4: setImage4(file); break;
                                                                                    case 5: setImage5(file); break;
                                                                                    default: break;
                                                                                }
                                                                            }
                                                                        }}
                                                                    />
                                                                    {num === 1 && (
                                                                        <ItemGambar1
                                                                            onclick={() => { }}
                                                                            imageSrc1={image1 ? URL.createObjectURL(image1) : null}
                                                                        />
                                                                    )}
                                                                    {num === 2 && (
                                                                        <ItemGambar2
                                                                            onclick={() => { }}
                                                                            imageSrc2={image2 ? URL.createObjectURL(image2) : null}
                                                                        />
                                                                    )}
                                                                    {num === 3 && (
                                                                        <ItemGambar3
                                                                            onclick={() => { }}
                                                                            imageSrc3={image3 ? URL.createObjectURL(image3) : null}
                                                                        />
                                                                    )}
                                                                    {num === 4 && (
                                                                        <ItemGambar4
                                                                            onclick={() => { }}
                                                                            imageSrc4={image4 ? URL.createObjectURL(image4) : null}
                                                                        />
                                                                    )}
                                                                    {num === 5 && (
                                                                        <ItemGambar5
                                                                            onclick={() => { }}
                                                                            imageSrc5={image5 ? URL.createObjectURL(image5) : null}
                                                                        />
                                                                    )}
                                                                </label>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </CardBody>

                                    <CardFooter disabled={loading} className="d-flex justify-content-between">
                                        <Link className="btn btn-info" to="/mobile/sales/page">
                                            Kembali
                                        </Link>
                                        <Button disabled={loading} color="danger" onClick={() => setQuestionAlert()}>
                                            Simpan
                                        </Button>
                                    </CardFooter>
                                </Card>

                            </>
                        ) : (
                            <p className="text-center">Loading lokasi proyek...</p>
                        )}
                    </Container>
                </>)}
            </div>
        </>
    );
}
